import { useMemo } from 'react';
import { useImportExportApi } from '../../../clients/quipli-service/import-export/import-export-api';
import { ImportExportAdapter } from '../../../components/import-export/types';
import { DateTime } from 'luxon';
import { Typography } from '../../../components/typography/typography';
import { toast } from '../../../util/toasts';

type CustomersImportParams = Record<string, never>;
type CustomersExportParams = Record<string, never>;

export const useCustomersImportExportAdapter = (
  fetchCallback: () => void,
): ImportExportAdapter<CustomersImportParams, CustomersExportParams> => {
  const api = useImportExportApi();

  return useMemo(
    () => ({
      typeLabel: 'customers',
      fileAccept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',

      defaultExportFileName: () => `Customers_${DateTime.local().toFormat('D').replaceAll('/', '-')}`,

      export: () => api.exportCustomers(),
      import: (file: File) => api.importCustomers(file),
      exportSample: () => api.exportCustomersSample(),

      onImportSuccess: () => {
        toast('File uploaded successfully. You will received an email when the import is complete.', 'success');
        fetchCallback();
      },
      onImportError: () => {
        toast('Error importing customers', 'error');
        fetchCallback();
      },
      onExportSuccess: () => {
        fetchCallback();
      },
      onExportError: () => {
        toast('Error exporting customers', 'error');
        fetchCallback();
      },

      renderSampleFile: ({ exportSampleFile }: { exportSampleFile: () => void }) => (
        <div className="text-left px-4 mb-4">
          <Typography type="text-sm" className="text-grey-500">
            <div>Import customers from a XLS or XLSX spreadsheet file.</div>
            <div>
              Click{' '}
              <a className="text-quipli-black-800 underline cursor-pointer" onClick={exportSampleFile}>
                here
              </a>{' '}
              to see the exact format of the worksheets.
            </div>
          </Typography>
        </div>
      ),
    }),
    [fetchCallback],
  );
};
